import { InputNumber } from 'antd';
import { forwardRef } from 'react';
import type { ComponentRef, Ref } from 'react';
import type { AppInputNumberProps, AppInputNumberValue } from './InputNumber.types';

export type AppInputNumberRef = ComponentRef<typeof InputNumber>;

const InputNumberComponent = <T extends AppInputNumberValue = number>(
  props: AppInputNumberProps<T>,
  ref: Ref<AppInputNumberRef>,
) => {
  const { type = 'number', controls = false, ...rest } = props;

  return <InputNumber type={type} controls={controls} {...rest} ref={ref} />;
};

export const AppInputNumber = forwardRef(InputNumberComponent) as <
  T extends AppInputNumberValue = number,
>(
  props: AppInputNumberProps<T> & { ref?: Ref<AppInputNumberRef> },
) => ReturnType<typeof InputNumberComponent>;
